var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var getAllNodesWithType = function (editor, type) {
    var nodes = [];
    editor.view.state.doc.descendants(function (node, pos) {
        if (node.type.name === type) {
            nodes.push({
                pos: pos,
                id: node.attrs.id,
                label: node.attrs.label,
            });
        }
    });
    return nodes;
};
export var updateNodeAttributes = function (editor, pos, attributes) {
    var state = editor.state;
    var tr = state.tr;
    var node = state.doc.nodeAt(pos);
    if (node) {
        tr.setNodeMarkup(pos, null, __assign(__assign({}, node.attrs), attributes));
        editor.view.dispatch(tr);
    }
};
